import {
    CLIENT_TIME_ZONES,
    type ClientTimeZone,
} from '@nesso/client-contracts/client-profile.time-zones';

export type TimeZoneOption = { value: ClientTimeZone; label: string };

const TIME_ZONE_LABELS: Record<ClientTimeZone, string> = {
    'America/New_York': 'Eastern Time (ET)',
    'America/Chicago': 'Central Time (CT)',
    'America/Denver': 'Mountain Time (MT)',
    'America/Phoenix': 'Arizona (MST), no daylight saving time',
    'America/Los_Angeles': 'Pacific Time (PT)',
    'America/Anchorage': 'Alaska Time (AKT)',
    'Pacific/Honolulu': 'Hawaii-Aleutian Time (HST), no daylight saving time',
};

const TIME_ZONE_OPTIONS: TimeZoneOption[] = CLIENT_TIME_ZONES.map((zone) => ({
    value: zone,
    label: TIME_ZONE_LABELS[zone],
}));

const DEFAULT_TIME_ZONE: ClientTimeZone = 'America/New_York';

function getBrowserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function findClientTimeZone(zone: string): ClientTimeZone | undefined {
    return CLIENT_TIME_ZONES.find((clientZone) => clientZone === zone);
}

// FR-016: the therapist's own zone seeds a client with none saved, but the rest of this form is
// US-only (US states, US phone, 5-digit ZIP), so a browser zone outside the curated seven lands on
// Eastern rather than widening the select with a zone the product doesn't otherwise support.
export function getDefaultTimeZone(browserTimeZone: string = getBrowserTimeZone()): ClientTimeZone {
    return findClientTimeZone(browserTimeZone) ?? DEFAULT_TIME_ZONE;
}

// Rows saved before the contract became an enum may hold any IANA id; the form can only offer
// the contract's zones, so those open on the default instead of a value the select can't show.
export function toClientTimeZone(stored: string | null): ClientTimeZone {
    return (stored && findClientTimeZone(stored)) || getDefaultTimeZone();
}

export function getTimeZoneOptions(): TimeZoneOption[] {
    return TIME_ZONE_OPTIONS;
}
